import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getValidJwt, getRole } from "@/lib/auth";

export function ProtectedRoute({
  children,
  requireAdmin = false,
}: {
  children: ReactNode;
  requireAdmin?: boolean;
}) {
  const location = useLocation();
  if (!getValidJwt()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (requireAdmin && getRole() !== "admin") {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
